'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
require('./_index.scss.js');

var CLASSNAME = 'varta-icon';
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function Icon(_ref) {
  var className = _ref.className,
      color = _ref.color,
      id = _ref.id,
      size = _ref.size,
      style = _ref.style,
      viewBox = _ref.viewBox;
  var sizeClass = "".concat(CLASSNAME, "--").concat(size);
  var styles = Object.assign({
    fill: color
  }, style);
  return /*#__PURE__*/React__default.createElement("span", {
    className: classNames(CLASSNAME, className, sizeClass),
    style: styles
  }, /*#__PURE__*/React__default.createElement("svg", {
    viewBox: viewBox
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#icon-".concat(id)
  })));
}
Icon.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Icon color */
  color: PropTypes.string,

  /** String that matches icon id from <Icons /> */
  id: PropTypes.string.isRequired,

  /** Icon size */
  size: PropTypes.oneOf(['xxs', 'xs', 'sm', 'md', 'lg', 'xl']),

  /** Custom styles */
  style: PropTypes.object,

  /** Viewbox for icon svg */
  viewBox: PropTypes.string
};
Icon.defaultProps = {
  size: 'md',
  viewBox: '0 0 32 32'
};

module.exports = Icon;
